import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { InboundFilesRoute } from '../../routing'

export class InboundFilesPage extends Component {
    render() {
        return (
            <Fragment>
                <Breadcrumbs />
                <InboundFilesRoute />
            </Fragment>
        )
    }
}
